export const SESSION_WORKLIST_PREFERENCES = 'sessionWorklistPreferences'

// 'sessionTaskPreferences' is part of the type contract but has no runtime caller yet;
// kept as a string literal rather than an unused exported const.
type SessionType = typeof SESSION_WORKLIST_PREFERENCES | 'sessionTaskPreferences'

export const setPreferences = (preference: string, sessionType: SessionType) =>
  localStorage.setItem(sessionType, preference)
export const getPreferences = (sessionType: SessionType) => localStorage.getItem(sessionType)
